import { TFunction } from "i18next";
import { CandidateLayoutProps } from "layouts/pages/CandidateLayout";

import { PageContentProps } from "content/content.types";

const pageContent = (
    t: TFunction,
    _pageContent: PageContentProps
): CandidateLayoutProps => ({
    title: t("candidate:title"),
});

export default pageContent;
